import React from "react";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Work from "../components/Work";
const Home = () => {
  return <div>
    <Navbar /> 
    <Hero />
    <Work />
    <Footer />
  </div>;
};

export default Home